(() => {
  if (window.bazV4DiscoveryReady) return;
  window.bazV4DiscoveryReady = true;

  const applyFilter = (directory, group, announce = true) => {
    let visible = 0;
    directory.querySelectorAll('[data-b4d-category]').forEach(card => {
      const matches = group === 'all' || card.dataset.b4dCategory === group || card.dataset.b4dCategory === 'both';
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    directory.querySelectorAll('[data-b4d-filter]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.b4dFilter === group));
    });
    const empty = directory.querySelector('[data-b4d-filter-empty]');
    if (empty) empty.hidden = visible > 0;
    const status = directory.querySelector('[data-b4d-filter-status]');
    if (status && announce) status.textContent = `${visible} ${directory.dataset.b4dStatusLabel}`;
  };

  const initialize = (root = document) => {
    const directories = [...root.querySelectorAll('[data-b4d-directory]')];
    if (root instanceof Element && root.matches('[data-b4d-directory]')) directories.unshift(root);
    directories.forEach(directory => {
      if (directory.dataset.b4dReady === 'true') return;
      directory.dataset.b4dReady = 'true';
      const controls = directory.querySelector('[data-b4d-filter-controls]');
      if (controls) controls.hidden = false;
      applyFilter(directory, 'all', false);
    });
  };

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-b4d-filter]');
    if (!button) return;
    const directory = button.closest('[data-b4d-directory]');
    if (directory) applyFilter(directory, button.dataset.b4dFilter);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    if (!(event.target instanceof Element)) return;
    const directory = event.target.closest('[data-b4d-directory]');
    if (directory) applyFilter(directory, 'all', false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
